<div *ngIf="hasAccounts" class="p-4 md:p-8" style="max-width: 520px; margin: 0 auto;">

  <!-- Header con progreso -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 16px 20px; margin-bottom: 20px;">
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <button type="button" (click)="previousStep()"
        [disabled]="isTransitioning"
        [style.opacity]="isTransitioning ? '0.5' : '1'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
        onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #374151;">arrow_back</mat-icon>
        Atr&aacute;s
      </button>
      <span style="background: #1C593D; color: white; padding: 4px 14px; border-radius: 20px; font-size: 0.8rem; font-weight: 700;">
        Paso {{ currentStep }}/{{ totalSteps }}
      </span>
    </div>
    <div style="width: 100%; height: 8px; background: #dcfce7; border-radius: 20px; overflow: hidden;">
      <div style="height: 100%; background: #1C593D; border-radius: 20px; transition: width 0.3s ease;"
        [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>
  </div>

  <!-- ===== STEP 1: Calculadora ===== -->
  <div *ngIf="currentStep === 1" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Calcula tu retiro</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Ingresa el monto a retirar en Bol&iacute;vares</p>
    </div>
    <app-calculator-withdraw-ves #calculatorComponent
      (montoRetiroEmit)="assignMontoRetiro($event)"
      (changeStep)="goToNextStep()"
      [saldoActual]="saldoActual">
    </app-calculator-withdraw-ves>
  </div>

  <!-- ===== STEP 2: Beneficiario ===== -->
  <div *ngIf="currentStep === 2" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Elige tu beneficiario</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Selecciona la cuenta donde recibir&aacute;s tus fondos</p>
    </div>
    <app-withdraw-accounts-step-ves #beneficiarioComponent
      [montoRetiro]="montoRetiro"
      (changeStep)="goToNextStep()"
      (beneficiarioOutput)="assignAccount($event)">
    </app-withdraw-accounts-step-ves>
  </div>

  <!-- ===== STEP 3: Resumen ===== -->
  <div *ngIf="currentStep === 3" class="step-slide" [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <div style="text-align: center; margin-bottom: 20px;">
      <h2 style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">Resumen del retiro</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Confirma los datos de tu operaci&oacute;n</p>
    </div>
    <app-withdraw-summary-order-ves
      [montoRetiro]="montoRetiro"
      [account]="accountSelected"
      [usuarioId]="userId">
    </app-withdraw-summary-order-ves>
  </div>

</div>
